export default __webpack_public_path__ + "static/media/Stamp8.54294338.svg";